const lineCommand = point => `L ${point[0]} ${point[1]}`


/// START BEZIER 
// First, a function to find the properties of the opposed-line:
// Properties of a line 
// I:  - pointA (array) [x,y]: coordinates
//     - pointB (array) [x,y]: coordinates
// O:  - (object) { length: l, angle: a }: properties of the line
const line = (pointA, pointB) => {
    const lengthX = pointB[0] - pointA[0]
    const lengthY = pointB[1] - pointA[1]
    return {
    length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
    angle: Math.atan2(lengthY, lengthX)
    }
}
// Position of a control point 
// I:  - current (array) [x, y]: current point coordinates
//     - previous (array) [x, y]: previous point coordinates
//     - next (array) [x, y]: next point coordinates
//     - reverse (boolean, optional): sets the direction
// O:  - (array) [x,y]: a tuple of coordinates
const controlPoint = (current, previous, next, reverse) => {
    // When 'current' is the first or last point of the array
    // 'previous' or 'next' don't exist.
    // Replace with 'current'
    const p = previous || current
    const n = next || current
    // The smoothing ratio
    const smoothing = 0.2
    // Properties of the opposed-line
    const o = line(p, n)
    // If is end-control-point, add PI to the angle to go backward
    const angle = o.angle + (reverse ? Math.PI : 0)
    const length = o.length * smoothing
    // The control point position is relative to the current point
    const x = current[0] + Math.cos(angle) * length
    const y = current[1] + Math.sin(angle) * length

    // limit the amount of decimals
    const x1 = Math.round(x * 1000) / 1000;
    const y1 = Math.round(y * 1000) / 1000;
    return [x1, y1]
}

// Create the bezier curve command 
// I:  - point (array) [x,y]: current point coordinates
//     - i (integer): index of 'point' in the array 'a'
//     - a (array): complete array of points coordinates
// O:  - (string) 'C x2,y2 x1,y1 x,y': SVG cubic bezier C command
const bezierCommand = (point, i, a) => {
    // start control point
    const [cpsX, cpsY] = controlPoint(a[i - 1], a[i - 2], point)
    // end control point
    const [cpeX, cpeY] = controlPoint(point, a[i - 1], a[i + 1], true)
    return `C ${cpsX},${cpsY} ${cpeX},${cpeY} ${point[0]},${point[1]}`
}


// Render the svg <path> element 
// I:  - points (array): points coordinates
//     - command (function)
//       I:  - point (array) [x,y]: current point coordinates
//           - i (integer): index of 'point' in the array 'a'
//           - a (array): complete array of points coordinates
//       O:  - (string) a svg path command
// O:  - (string): a Svg <path> element
const svgPath = (points, command) => {
    // build the d attributes by looping over the points
    const d = points.reduce((acc, point, i, a) => i === 0
    // if first point
    ? `M ${point[0]},${point[1]}`
    // else
    : `${acc} ${command(point, i, a)}`
    , '')
    return d //`<path d="${d}" fill="none" stroke="grey" />`
}
//const p = [[this.x1,this.y1], [this.x2,this.y2]]
//var curve = svgPath(p, lineCommand)
//var curve = svgPath(p, bezierCommand)

// TODO: see also https://codepen.io/francoisromain/pen/YxyEQL










function makeBezier2(points) {
    if(points.length == 2) {
        // create additional points
        let p1 = points[0],
            p2 = points[1],
            p1x = p1[0], p1y = p1[1],
            p2x = p2[0], p2y = p2[1],
            extras = [];
        // REMEMBER: lower y = top
        //if(p1x < p2x || true) {
            // TL -> BR & BL => TR
            extras[extras.length] = [
                Math.round(
                    p1x + ((p2x - p1x) * 0.3)
                ),
                Math.round(
                   // p1y// p1y - ( (p2y - p1y) * 0.001 )
                    p1y + ( (p2y - p1y) * 0.15 )
                )
            ];
            extras[extras.length] = [
                Math.round(
                    p1x + ((p2x - p1x) * 0.7)
                ),
                Math.round(
                    p2y - ( (p2y - p1y) * 0.15 )
                )
            ];
        //}
        if(extras.length > 0) {
            points = [p1].concat(extras).concat([p2])
            
           // return svgPath(points, lineCommand);
        }
    }
    return svgPath(points, bezierCommand);
}


function makeBezier(points) {
    return svgPath(points, bezierCommand);
}

function makeLine(points) {
    return svgPath(points, lineCommand);
}

export {svgPath, makeBezier, makeBezier2, makeLine, lineCommand, bezierCommand}

